import { Matcher } from '../interfaces/jwt-config.type';

export function convertMatcher(input: Matcher): string | RegExp {
  if (typeof input === 'string') {
    return input;
  } else {
    return new RegExp(input.match, input.flags);
  }
}
